import { render } from "./ModuleSelector.vue?vue&type=template&id=6cf05198&scoped=true"
import script from "./ModuleSelector.vue?vue&type=script&lang=js"
export * from "./ModuleSelector.vue?vue&type=script&lang=js"

import "./ModuleSelector.vue?vue&type=style&index=0&id=6cf05198&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf05198"]])

export default __exports__